import React, { useEffect, useState } from 'react'
import axios from 'axios'
import SeoHelmet from '../components/SeoHelmet'
import { seo } from '../config/seo'
import '../styles/dashboard.css'
import question from '../static/pictures/question.png'
import { fixedDate } from '../functions/dates'

import {getToken} from '../functions/loginVerification'
import { logout } from '../functions/logout'
import { addDaily } from '../functions/addDaily'

import { useNavigate } from 'react-router-dom'
import { addInformation } from '../functions/addInformation'
import { addEvent } from '../functions/addEvent'
import { getEvents } from '../functions/getEvents'
import { filterEvents } from '../functions/filterEvents'
import { addArchivePhotos } from '../functions/addArchivePhotos'
import { addDolezite, addImportant } from '../functions/addImportant'
import { getAllInstructors } from '../functions/getAllInstructors'
import { addInstructor } from '../functions/addInstructor'
import { deteleInstructors } from '../functions/deleteInstructor'
import { updateInstructor } from '../functions/updateInstructor'
import { getPricelist } from '../functions/getPricelist'
import { savePricelist } from '../functions/savePricelist'
import { seasonChecking } from '../functions/seasonChecking'
import { getOpeningHours } from '../functions/getOpeningHours'
import { saveOpeningHours } from '../functions/saveOpeningHours'
import { addWarning } from '../functions/addWarning'
import { deleteInformation } from '../functions/deleteInformation'
import { deleteEvent } from '../functions/deleteEvent'
import { deleteWarning } from '../functions/deleteWarning'
import { deleteImportant } from '../functions/deleteImportant'
import { getWarnings } from '../functions/getWarnings'
import { getAllImportant } from '../functions/getAllImportant'
import { getCameraVisibility } from '../functions/getCameraVisibility'
import { saveCameraVisibility } from '../functions/saveCameraVisibility'

const Dashboard = () => {

    const navigate = useNavigate();

    const [response, setResponse] = useState([]);
    const [dashChoice, setDashChoice] = useState(0);
    const [deleteDash, setDeleteDash] = useState(0);
    const [deleteDashChoice, setDeleteDashChoice] = useState(1);
    
    const [header, setHeader] = useState("");
    const [text, setText] = useState("");

    const [eventName, setEventName] = useState("");
    const [eventText, setEventText] = useState("");
    const [eventPics, setEventPics] = useState([]);
    const [eventStart, setEventStart] = useState("");

    const [dailyText, setDailyText] = useState("");

    const [message, setMessage] = useState("");
    const [allEvents, setAllEvents] = useState([]);
    const [choosingPodujatia, setChoosingPodujatia] = useState(1);
    const [chosenPodujatie, setChosenPodujatie] = useState([]);
    const [podujatiePics, setPodujatiePics] = useState([]);

    const [doletizeHeader, setDoleziteHeader] = useState("");
    const [doleziteText, setDoleziteText] = useState("");

    const [warningHeader, setWarningHeader] = useState("");
    const [warningText, setWarningText] = useState("");

    const [instruktori, setInstruktori] = useState([]);
    const [instruktorName, setInstruktorName] = useState("");
    const [instruktorTelephone, setInstruktorTelephone] = useState("");
    const [instruktorZameranie, setInstruktorZameranie] = useState("Lyžovanie");
    const [messageDelete, setMessageDelete] = useState("");
    const [editingInstructor, setEditingInstructor] = useState(null);
    const [pricelist, setPricelist] = useState(null);

    const [deleteInformationList, setDeleteInformationList] = useState([]);
    const [deleteEventsList, setDeleteEventsList] = useState([]);
    const [deleteWarningsList, setDeleteWarningsList] = useState([]);
    const [deleteImportantList, setDeleteImportantList] = useState([]);

    // Opening hours state
    const [openingMode, setOpeningMode] = useState('static'); // 'static' or 'dynamic'
    const [staticHours, setStaticHours] = useState({
        // Summer defaults
        bufet: { PO: 'ZATVORENÉ', UT: 'ZATVORENÉ', ST: 'ZATVORENÉ', ŠT: 'ZATVORENÉ', PI: '16:00 - 20:00', SO: '12:00 - 20:00', NE: '12:00 - 18:00' },
        traily: { PO: 'ZATVORENÉ', UT: 'ZATVORENÉ', ST: 'ZATVORENÉ', ŠT: 'ZATVORENÉ', PI: 'ZATVORENÉ', SO: '13:00 - 17:00', NE: 'ZATVORENÉ' },
        // Winter defaults
        openingHours: { PO: 'ZATVORENÉ', UT: 'ZATVORENÉ', ST: 'ZATVORENÉ', ŠT: 'ZATVORENÉ', PI: '9:00 - 16:00', SO: '9:00 - 16:00', NE: '9:00 - 16:00' }
    });
    const [dynamicDates, setDynamicDates] = useState([]);
    const [currentStatus, setCurrentStatus] = useState({
        openSlopes: '',
        openLifts: '',
        snowDepth: ''
    });

    // Camera visibility state
    const [cameraHidden, setCameraHidden] = useState(false);
    const [cameraHiddenUntil, setCameraHiddenUntil] = useState(null);
    const [cameraMessage, setCameraMessage] = useState('Záznam z kamery je momentálne nedostupný.');
    const [cameraHideMode, setCameraHideMode] = useState('duration'); // 'duration' | 'until' | 'forever'
    const [cameraHideHours, setCameraHideHours] = useState('1');
    const [cameraHideUntilInput, setCameraHideUntilInput] = useState('');

    const isSummer = seasonChecking();

    useEffect(() => {
        const dashboardOpen = async() => {
            const data = await getToken();
            setResponse(data);
        }
        const events = async() => {
            const allEvents = await getEvents();
            const filteredOld = filterEvents(allEvents.data, 1, allEvents.data.length);
            setAllEvents(filteredOld);
        }

        const OnStart = async() => {
            const instruktori = await getAllInstructors();
            setInstruktori(instruktori.instructors);
        }
        
        dashboardOpen();
        events();
        OnStart();
    }, []);

    const selectDashChoice = (choice) => {
        if(choice === 0){
            setDashChoice(0);
            setMessage("");
        }
        else if(choice === 1){
            setDashChoice(1);
            setMessage("");
        }
        else if(choice === 2){
            setDashChoice(2);
            setMessage("");
        }
        else if(choice === 3){
            setDashChoice(3);
            setMessage("");
        }
        else if(choice === 4){
            setDashChoice(4);
            setMessage("");
        } else if(choice === 9){
            setDashChoice(9);
            setMessage("");
        }
        else if(choice === 10){
            setDashChoice(10);
            setMessage("");
        }
        else if(choice === 11){
            setDashChoice(11);
            setMessage("");
            loadOpeningHours();
        }
        else if(choice === 12){
            setDashChoice(12);
            setMessage("");
        }
        else if(choice === 16){
            setDashChoice(16);
            setMessage("");
            loadPricelist();
        }
        else if(choice === 15){
            setDashChoice(15);
            setMessage("");
            loadCameraVisibility();
        }
        else if(choice === 5){
            setDashChoice(1);
            setDeleteDash(1);
            setDeleteDashChoice(1);
            setMessage("");
            loadInformationForDelete();
        }
        else if(choice === 6){
            setDeleteDashChoice(1);
            setDeleteDash(0);
            setMessage("");
        }
        else if(choice === 7){
            setDeleteDashChoice(1);
            setMessage("");
            loadInformationForDelete();
        }
        else if(choice === 8){
            setDeleteDashChoice(2);
            setMessage("");
            loadEventsForDelete();
        }
        else if(choice === 13){
            setDeleteDashChoice(3);
            setMessage("");
            loadWarningsForDelete();
        }
        else if(choice === 14){
            setDeleteDashChoice(4);
            setMessage("");
            loadImportantForDelete();
        }
    }

    const loadInformationForDelete = async () => {
        const resp = await axios.get(`${process.env.REACT_APP_API_HOST}/information/all`);
        setDeleteInformationList(resp.data);
    }

    const loadEventsForDelete = async () => {
        const events = await getEvents();
        setDeleteEventsList(events.data || []);
    }

    const loadWarningsForDelete = async () => {
        const data = await getWarnings();
        setDeleteWarningsList(data);
    }

    const loadImportantForDelete = async () => {
        const data = await getAllImportant();
        setDeleteImportantList(data.data || []);
    }

    const handleDeleteInformation = async (id, header) => {
        if (!window.confirm(`Naozaj chcete vymazať informáciu „${header}"?`)) return;
        setMessage("");
        const response = await deleteInformation(id);
        if (response) {
            setMessage(response.message);
            loadInformationForDelete();
        }
    }

    const handleDeleteEvent = async (id, header) => {
        if (!window.confirm(`Naozaj chcete vymazať podujatie „${header}"?`)) return;
        setMessage("");
        const response = await deleteEvent(id);
        if (response) {
            setMessage(response.message);
            loadEventsForDelete();
            const allEvents = await getEvents();
            setAllEvents(filterEvents(allEvents.data, 1, allEvents.data.length));
        }
    }

    const handleDeleteWarning = async (id, header) => {
        if (!window.confirm(`Naozaj chcete vymazať upozornenie „${header}"?`)) return;
        setMessage("");
        const response = await deleteWarning(id);
        if (response) {
            setMessage(response.message);
            loadWarningsForDelete();
        }
    }

    const handleDeleteImportant = async (id, header) => {
        if (!window.confirm(`Naozaj chcete vymazať dôležité info „${header}"?`)) return;
        setMessage("");
        const response = await deleteImportant(id);
        if (response) {
            setMessage(response.message);
            loadImportantForDelete();
        }
    }

    const formInfo = async(e) => {
        e.preventDefault();
        if(header.length !== 0 && text.length !== 0) {
            const response = await addInformation(header, text);
            setMessage(response.message);
        } else setMessage("Nedostatok informácii!");
    }

    const formDaily = async(e) => {
        e.preventDefault();
        if(dailyText.length !== 0) {
            const response = await addDaily(dailyText);
            setMessage(response.message);
        } else setMessage("Nedostatok informácii!");
    }

    const formEvent = async(e) => {
        e.preventDefault();
        setMessage("");
        if(eventName.length !== 0 && eventText.length !== 0) {
            const formData = new FormData();
            formData.append("eventName", eventName);
            formData.append("eventText", eventText);
            formData.append("startDate", eventStart);
            for(let x = 0; x < eventPics.length; x++) {
                formData.append("file", eventPics[x]);
            }
            const response = await addEvent(formData);
            setMessage(response.message);
        } else setMessage('Nedostatok informacii!');
    }

    const podujatieArchivFotky = async(e) => {
        e.preventDefault();
        setMessage("");
        if(podujatiePics.length !== 0) {
            const formData = new FormData();
            formData.append("id", chosenPodujatie.id);
            for(let x = 0; x < podujatiePics.length; x++) {
                formData.append("file", podujatiePics[x]);
            }
            const response = await addArchivePhotos(formData);
            setMessage(response.message);
        } else setMessage('Je potrebné pridať fotky!');
    }

    const formDolezite = async(e) => {
        e.preventDefault();
        setMessage("");
        if(doletizeHeader.length !== 0 || doleziteText.length !== 0) {
            const response = await addImportant(doletizeHeader, doleziteText);
            setMessage(response.message);
        } else setMessage('Je potrebné zadať údaje');
    }

    const formWarning = async(e) => {
        e.preventDefault();
        setMessage("");
        if (warningHeader.length !== 0 && warningText.length !== 0) {
            const response = await addWarning(warningHeader, warningText);
            setMessage(response.message);
        } else setMessage("Nedostatok informácii!");
    }

    const formInstruktori = async(e) => {
        e.preventDefault();
        setMessage("");
        if(instruktorName.length > 2 && instruktorTelephone.length > 2) {
            const response = await addInstructor(instruktorName, instruktorTelephone, instruktorZameranie);
            setMessage(response.message);
        } else setMessage("Nedostatok informácii!");
    }

    const reloadInstructors = async() => {
        const data = await getAllInstructors();
        setInstruktori(data.instructors);
    }

    const deleteInstructor = async(id) => {
        setMessageDelete("");
        const response = await deteleInstructors(id);
        setMessageDelete(response.message);
        reloadInstructors();
    }

    const saveEditedInstructor = async(e) => {
        e.preventDefault();
        setMessageDelete("");
        const { id, meno, telefon, zameranie } = editingInstructor;
        if(meno.trim().length > 2 && telefon.trim().length > 2) {
            const response = await updateInstructor(id, meno, telefon, zameranie);
            setMessageDelete(response.message);
            if(response.ok) {
                setEditingInstructor(null);
                reloadInstructors();
            }
        } else setMessageDelete("Nedostatok informácii!");
    }

    const loadPricelist = async() => {
        const response = await getPricelist();
        if(response.ok) setPricelist(response.data);
        else setMessage(response.message);
    }

    // Edit one cell of a pricelist row (list = 'tickets' | 'rental').
    const changePricelistCell = (list, index, field, value) => {
        setPricelist(prev => ({
            ...prev,
            [list]: prev[list].map((row, i) => i === index ? { ...row, [field]: value } : row)
        }));
    }

    const addPricelistRow = (list) => {
        const empty = list === 'tickets'
            ? { name: '', adult: '', child: '' }
            : { name: '', h1: '', h2: '', h3: '', h4: '', day: '' };
        setPricelist(prev => ({ ...prev, [list]: [...prev[list], empty] }));
    }

    const removePricelistRow = (list, index) => {
        setPricelist(prev => ({ ...prev, [list]: prev[list].filter((_, i) => i !== index) }));
    }

    const submitPricelist = async(e) => {
        e.preventDefault();
        setMessage("");
        const response = await savePricelist(pricelist);
        setMessage(response.message);
        if(response.ok) setPricelist(response.data);
    }

    const loadCameraVisibility = async () => {
        try {
            const data = await getCameraVisibility();
            setCameraHidden(data.hidden === true);
            setCameraHiddenUntil(data.hiddenUntil || null);
            if (data.message) setCameraMessage(data.message);

            // Preselect the mode matching what is currently stored
            if (data.hidden && data.hiddenUntil) {
                setCameraHideMode('until');
                setCameraHideUntilInput(toLocalInputValue(data.hiddenUntil));
            } else if (data.hidden) {
                setCameraHideMode('forever');
            }
        } catch (error) {
            console.error('Error loading camera visibility:', error);
            setMessage('Chyba pri načítaní nastavenia kamery');
        }
    }

    // <input type="datetime-local"> needs local time without a timezone suffix
    const toLocalInputValue = (iso) => {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    const formatUntil = (iso) => {
        const d = new Date(iso);
        return isNaN(d.getTime()) ? '' : d.toLocaleString('sk-SK');
    }

    const hideCamera = async (e) => {
        e.preventDefault();
        setMessage("");

        let until = null;
        if (cameraHideMode === 'duration') {
            const hours = parseFloat(cameraHideHours);
            if (!hours || hours <= 0) {
                setMessage('Zadajte platný počet hodín!');
                return;
            }
            until = new Date(Date.now() + hours * 60 * 60 * 1000).toISOString();
        } else if (cameraHideMode === 'until') {
            if (!cameraHideUntilInput) {
                setMessage('Vyberte dátum a čas!');
                return;
            }
            const parsed = new Date(cameraHideUntilInput);
            if (isNaN(parsed.getTime())) {
                setMessage('Neplatný dátum a čas!');
                return;
            }
            if (parsed.getTime() <= Date.now()) {
                setMessage('Čas musí byť v budúcnosti!');
                return;
            }
            until = parsed.toISOString();
        }
        // 'forever' leaves until === null

        const response = await saveCameraVisibility(true, until, cameraMessage);
        setMessage(response.message || 'Nastavenie kamery uložené');
        if (response.ok && response.data) {
            setCameraHidden(response.data.hidden);
            setCameraHiddenUntil(response.data.hiddenUntil);
            setCameraMessage(response.data.message);
        }
    }

    const showCamera = async () => {
        setMessage("");
        const response = await saveCameraVisibility(false, null, cameraMessage);
        setMessage(response.message || 'Nastavenie kamery uložené');
        if (response.ok && response.data) {
            setCameraHidden(response.data.hidden);
            setCameraHiddenUntil(response.data.hiddenUntil);
            setCameraMessage(response.data.message);
        }
    }

    const loadOpeningHours = async () => {
        try {
            const data = await getOpeningHours();
            console.log('Opening hours data:', data);
            if (data.ok && data.data) {
                setOpeningMode(data.data.mode || 'static');
                if (data.data.staticHours) {
                    setStaticHours(data.data.staticHours);
                }
                if (data.data.dynamicDates) {
                    setDynamicDates(data.data.dynamicDates);
                }
                if (data.data.currentStatus) {
                    setCurrentStatus(data.data.currentStatus);
                }
            } else {
                console.error('Failed to load opening hours:', data.message);
                setMessage('Chyba pri načítaní otváracích hodín: ' + (data.message || 'Neznáma chyba'));
            }
        } catch (error) {
            console.error('Error in loadOpeningHours:', error);
            setMessage('Chyba pri načítaní otváracích hodín');
        }
    }

    const handleStaticHoursChange = (type, day, value) => {
        setStaticHours(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                [day]: value
            }
        }));
    }

    const handleDynamicDateChange = (index, field, value) => {
        const newDates = [...dynamicDates];
        if (!newDates[index]) {
            // Initialize based on season
            if (isSummer) {
                newDates[index] = { date: '', bufet: '', traily: '' };
            } else {
                newDates[index] = { date: '', openingHours: '' };
            }
        }
        newDates[index][field] = value;
        setDynamicDates(newDates);
    }

    const addDynamicDate = () => {
        const today = new Date();
        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + 14);
        
        const dateStr = maxDate.toISOString().split('T')[0];
        if (isSummer) {
            setDynamicDates([...dynamicDates, { date: dateStr, bufet: '', traily: '' }]);
        } else {
            setDynamicDates([...dynamicDates, { date: dateStr, openingHours: '' }]);
        }
    }

    const removeDynamicDate = (index) => {
        setDynamicDates(dynamicDates.filter((_, i) => i !== index));
    }

    const saveOpeningHoursData = async (e) => {
        e.preventDefault();
        setMessage("");
        
        // Prepare static hours based on season
        let hoursToSave = staticHours;
        if (openingMode === 'static') {
            if (isSummer) {
                // Summer: only save bufet and traily
                hoursToSave = {
                    bufet: staticHours.bufet,
                    traily: staticHours.traily
                };
            } else {
                // Winter: only save openingHours
                hoursToSave = {
                    openingHours: staticHours.openingHours
                };
            }
        }
        
        if (openingMode === 'static') {
            const response = await saveOpeningHours(openingMode, hoursToSave, null, isSummer, currentStatus);
            setMessage(response.message || 'Opening hours saved successfully');
        } else {
            if (dynamicDates.length === 0) {
                setMessage('Please add at least one date');
                return;
            }
            const response = await saveOpeningHours(openingMode, null, dynamicDates, isSummer, currentStatus);
            setMessage(response.message || 'Opening hours saved successfully');
        }
    }


  return (
    <div className="dashboard-page">
      <SeoHelmet title={seo.pages.dashboard.title} noIndex />
        {response.ok ? <>
            {deleteDash === 0 ?
            <div className="dash-bar">
                <div className="header"><h1>Administrácia<br/><small style={{fontSize: '17px'}}>{isSummer ? 'Summer season' : 'Winter season'}</small></h1></div>
                <div className="bar-option" onClick={()=>selectDashChoice(1)}><h3>Pridať informáciu</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(2)}><h3>Pridať podujatie</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(3)}><h3>Pridať fotky</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(4)}><h3>Pridať denné info</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(9)}><h3>Pridať dôležité</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(10)}><h3>Inštruktori</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(16)}><h3>Cenník</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(12)}><h3>Pridať upozornenie</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(11)}><h3>Otváranie</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(15)}><h3>Kamera</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(5)} style={{background: 'grey'}}><h3>Možnosti odstraňovania</h3></div>
                <div className="bar-option" onClick={async()=>{await logout(navigate, '/')}}><h3>Odhlásiť sa</h3></div>
            </div> : 
            <div className="dash-bar">
                <div className="header"><h1>Administrácia</h1></div>
                <div className="bar-option" onClick={()=>selectDashChoice(7)}><h3>Odstrániť informáciu</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(8)}><h3>Odstrániť podujatie</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(13)}><h3>Odstrániť upozornenie</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(14)}><h3>Odstrániť dôležité</h3></div>
                <div className="bar-option" onClick={()=>selectDashChoice(6)} style={{background: 'grey'}}><h3>Späť na pridávanie</h3></div>
                <div className="bar-option" onClick={async()=>{await logout(navigate, '/')}}><h3>Odhlásiť sa</h3></div>
            </div> }
            {dashChoice === 0 && deleteDash === 0 ?
            <div className="content">
                <div className="header"><h1>Vitaj, niko125</h1></div>
                <div className="information">
                    <img src={question} alt="exclamation"/>
                    <p>Vitaj v administrácii. K tejto časti stránky majú prístup iba administrátori. V tomto prostredí môžeš pridávať na svoju stránku rôzne udalosti, informácie, apod.. Vyber položku z ľavého panelu a začni pridávať!</p>
                </div>
            </div>
            : dashChoice === 1 && deleteDash === 0 ?
            <div className="content">
                <div className="header"><h1>Pridať informáciu</h1></div>
                <div className="login-form">
                    <form method="POST" onSubmit={(e)=>formInfo(e)}>
                        <label for="infoHeader">Názov informácie</label>
                        <input type="text" onChange={(e)=>setHeader(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. Lyžiarske stredisko znova otvorené!"/>

                        <label for="infoText">Text</label><br/>
                        <textarea onChange={(e)=>setText(e.target.value)}></textarea>
                        
                        <p>Informácia sa zobrazí na hlavnej stránke. Najnovšie dve pridané informácie sa zobrazujú na hlavnej stránke, ostatné sú filtrované!</p>
                        <p style={{color: 'lightgreen'}}>{message}</p>
                        <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj informáciu"/></div>
                    </form>
                </div>
            </div> 
            : dashChoice === 2 && deleteDash === 0 ? 
            <div className="content">
                <div className="header"><h1>Pridať podujatie</h1></div>
                <div className="login-form">
                    <form method="POST" onSubmit={(e)=>formEvent(e)} encType="multipart/form-data">
                        <label for="infoHeader">Názov poduajtia</label>
                        <input type="text" onChange={(e)=>setEventName(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. Príbehy pri ohni"/>

                        <label for="infoText">Popis podujatia</label><br/>
                        <textarea onChange={(e)=>setEventText(e.target.value)}></textarea><br/>
                        
                        <label for="infoHeader">Dátum začiatku podujatia</label>
                        <input type="text" onChange={(e)=>setEventStart(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. 22.3.2022"/>


                        <label for="file">Pridaj fotky pre podujatie:</label>
                        <input style={{color: 'white'}} onChange={(e)=>setEventPics(e.target.files)} type="file" multiple="multiple" name="file" id="file" />
                        
                        <p>Podujatia sa zobrazujú v zostupnom štýle. Najnovšie je vždy prvé, pod ním budú pridané fotky.</p>
                        <p style={{color: 'lightgreen'}}>{message}</p>
                        <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj podujatie"/></div>
                    </form>
                </div>
            </div>
            : dashChoice === 3 && deleteDash === 0 ? 
            <div className="content">
                <div className="header"><h1>Pridať fotky do archívu</h1></div>
                {choosingPodujatia === 1 ?<><p style={{color: 'white', textAlign: 'center', marginTop: '-15px'}}>Ako prvé vyberte z archívu podujatie, do ktorého chcete pridávať</p>
                <table id="events-table" style={{margin: '0 auto 20px auto'}}>
                    <tr>
                        <th style={{paddingLeft: '10px'}}>Názov podujatia</th>
                    </tr>
                    {allEvents.map((event, index) => <tr onClick={()=>{setChosenPodujatie(event); setChoosingPodujatia(0)}} tabIndex={index}><td>{event.header}</td></tr>)}
                </table></> 
                :  <>
                    <p style={{color: 'white', textAlign: 'center', marginTop: '-15px'}}>Pridajte fotky k tomuto podujatiu</p>
                    <p style={{color: 'gray', textAlign: 'center'}}>Vybraté podujatie: {chosenPodujatie.header}</p>
                    
                    <div className="login-form" style={{width: '50%'}}>
                        <form method="POST" style={{textAlign: 'center'}} onSubmit={(e)=>podujatieArchivFotky(e)} encType="multipart/form-data">
                            <label for="file">Pridaj fotky pre podujatie:</label>
                            <input style={{color: 'white'}} onChange={(e)=>setPodujatiePics(e.target.files)} type="file" multiple="multiple" name="file" id="file" />
                            
                            <p style={{textAlign: 'center'}}>Pridané fotky sa zobrazia v danom podujatí.</p>
                            <p style={{color: 'lightgreen', textAlign: 'center'}}>{message}</p>
                            <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj fotky"/></div>
                        </form>
                    </div>      
                   </>
                }
            </div>
            : dashChoice === 4 && deleteDash === 0 ? <div className="content">
            <div className="header"><h1>Pridať dennú informáciu</h1></div>
            <div className="login-form">
                <form method="POST" onSubmit={(e)=>formDaily(e)}>
                    <label for="infoText">Text</label><br/>
                    <textarea onChange={(e)=>setDailyText(e.target.value)}></textarea>
                    
                    <p>Denná informácia sa zobrazí v bočnom paneli stránky v rámčeku.</p>
                    <p style={{color: 'lightgreen'}}>{message}</p>
                    <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj dennú informáciu"/></div>
                </form>
            </div>
        </div> 
        : dashChoice === 9 && deleteDash === 0 ? 
        <div className="content">
            <div className="header"><h1>Pridať dôležité info</h1></div>
            <div className="login-form">
                    <form method="POST" onSubmit={(e)=>formDolezite(e)} encType="multipart/form-data">
                        <label for="infoHeader">Názov dôležitého infa</label>
                        <input type="text" onChange={(e)=>setDoleziteHeader(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. V sobotu je porada"/>

                        <label for="infoText">Text doležitého infa</label><br/>
                        <textarea onChange={(e)=>setDoleziteText(e.target.value)}></textarea><br/>
                
                        <p style={{color: 'lightgreen'}}>{message}</p>
                        <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj dôležité"/></div>
                    </form>
            </div>
        </div>
        : dashChoice === 10 && deleteDash === 0 ? 
        <div className="content">
            <div className="header"><h1>Inštruktori</h1></div>
            <div className="login-form">
                    <form method="POST" onSubmit={(e)=>formInstruktori(e)} encType="multipart/form-data">

                        <label for="infoHeader">Meno inštruktora</label>
                        <input type="text" onChange={(e)=>setInstruktorName(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. Jozef"/>

                        <label for="infoText">Telefón inštruktora</label><br/>
                        <input type="text" onChange={(e)=>setInstruktorTelephone(e.target.value)}  id="infoHeader" name="infoHeader" placeholder="napr. +421 985 478 998"/>
                
                        <label for="cars">Vyber zameranie:</label>
                        <select name="cars" onChange={(e)=>setInstruktorZameranie(e.target.value)} id="cars" form="carform">
                            <option value="Lyžovanie">Lyžovanie</option>
                            <option value="Snowboarding">Snowboarding</option>
                        </select>
                        <p style={{color: 'lightgreen'}}>{message}</p>
                        <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj inštruktora"/></div>
                    </form>
            </div>
            <h2 style={{textAlign: 'center', color: 'white'}}>Upraviť / vymazať inštruktora</h2>
            <p style={{color: 'lightgreen', textAlign: 'center'}}>{messageDelete}</p>
            {editingInstructor ? <div className="login-form">
                <form onSubmit={saveEditedInstructor}>
                    <label>Meno inštruktora</label>
                    <input type="text" value={editingInstructor.meno} onChange={(e)=>setEditingInstructor({...editingInstructor, meno: e.target.value})}/>

                    <label>Telefón inštruktora</label>
                    <input type="text" value={editingInstructor.telefon} onChange={(e)=>setEditingInstructor({...editingInstructor, telefon: e.target.value})}/>

                    <label>Zameranie</label>
                    <select value={editingInstructor.zameranie} onChange={(e)=>setEditingInstructor({...editingInstructor, zameranie: e.target.value})}>
                        <option value="Lyžovanie">Lyžovanie</option>
                        <option value="Snowboarding">Snowboarding</option>
                    </select>
                    <div style={{textAlign: 'center'}}>
                        <input type="submit" value="Uložiť zmeny"/>
                        <button type="button" onClick={()=>setEditingInstructor(null)} style={{marginLeft: '10px', padding: '14px 20px', borderRadius: '4px', border: 'none', cursor: 'pointer'}}>Zrušiť</button>
                    </div>
                </form>
            </div> : ''}
            <table id="events-table" style={{margin: '20px auto 20px auto', textAlign: 'center'}}>
                <tr>
                    <th style={{paddingLeft: '10px'}}>Meno</th>
                    <th style={{paddingLeft: '10px'}}>Číslo</th>
                    <th style={{paddingLeft: '10px'}}>Zameranie</th>
                    <th></th>
                </tr>
                {instruktori.map((instruktor, index) => <tr key={instruktor.id} tabIndex={index}>
                    <td>{instruktor.meno}</td>
                    <td>{instruktor.telefon}</td>
                    <td>{instruktor.zameranie}</td>
                    <td style={{whiteSpace: 'nowrap'}}>
                        <button type="button" onClick={()=>{setMessageDelete(""); setEditingInstructor({id: instruktor.id, meno: instruktor.meno || '', telefon: instruktor.telefon || '', zameranie: instruktor.zameranie || 'Lyžovanie'});}}>Upraviť</button>{' '}
                        <button type="button" onClick={()=>{ if(window.confirm(`Vymazať inštruktora ${instruktor.meno}?`)) deleteInstructor(instruktor.id); }}>Vymazať</button>
                    </td>
                </tr>)}
            </table>
        </div>
        : dashChoice === 16 && deleteDash === 0 ?
        <div className="content">
            <div className="header"><h1>Cenník</h1></div>
            {pricelist ? <form onSubmit={submitPricelist} style={{padding: '0 30px 30px'}}>
                <h2 style={{color: 'white'}}>Lístky</h2>
                <table style={{width: '100%', background: 'white'}}>
                    <tr><th>Lístok</th><th>Dospelý</th><th>Dieťa</th><th></th></tr>
                    {pricelist.tickets.map((row, i) => <tr key={i}>
                        <td><input type="text" value={row.name} onChange={(e)=>changePricelistCell('tickets', i, 'name', e.target.value)} style={{width: '100%', boxSizing: 'border-box', padding: '6px'}}/></td>
                        <td><input type="text" value={row.adult} onChange={(e)=>changePricelistCell('tickets', i, 'adult', e.target.value)} style={{width: '100%', boxSizing: 'border-box', padding: '6px'}}/></td>
                        <td><input type="text" value={row.child} onChange={(e)=>changePricelistCell('tickets', i, 'child', e.target.value)} style={{width: '100%', boxSizing: 'border-box', padding: '6px'}}/></td>
                        <td><button type="button" onClick={()=>removePricelistRow('tickets', i)}>✕</button></td>
                    </tr>)}
                </table>
                <button type="button" onClick={()=>addPricelistRow('tickets')} style={{margin: '10px 0'}}>+ Pridať lístok</button>

                <h3 style={{color: '#FFC93C'}}>Informácie pod lístkami (jeden riadok = jedna veta)</h3>
                <textarea value={pricelist.ticketInfo.join('\n')} onChange={(e)=>setPricelist({...pricelist, ticketInfo: e.target.value.split('\n')})} style={{width: '100%', minHeight: '140px', boxSizing: 'border-box'}}/>
                <h3 style={{color: '#FFC93C'}}>Červené upozornenie pod lístkami</h3>
                <input type="text" value={pricelist.ticketWarning} onChange={(e)=>setPricelist({...pricelist, ticketWarning: e.target.value})} style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}/>

                <h2 style={{color: 'white'}}>Požičovňa</h2>
                <table style={{width: '100%', background: 'white'}}>
                    <tr><th>Položka</th><th>1 hod.</th><th>2 hod.</th><th>3 hod.</th><th>4 hod.</th><th>Deň</th><th></th></tr>
                    {pricelist.rental.map((row, i) => <tr key={i}>
                        <td><input type="text" value={row.name} onChange={(e)=>changePricelistCell('rental', i, 'name', e.target.value)} style={{width: '100%', boxSizing: 'border-box', padding: '6px'}}/></td>
                        {['h1', 'h2', 'h3', 'h4', 'day'].map(f => <td key={f}><input type="text" value={row[f]} onChange={(e)=>changePricelistCell('rental', i, f, e.target.value)} style={{width: '100%', boxSizing: 'border-box', padding: '6px'}}/></td>)}
                        <td><button type="button" onClick={()=>removePricelistRow('rental', i)}>✕</button></td>
                    </tr>)}
                </table>
                <button type="button" onClick={()=>addPricelistRow('rental')} style={{margin: '10px 0'}}>+ Pridať položku</button>

                <h3 style={{color: '#FFC93C'}}>Upozornenie pod požičovňou</h3>
                <input type="text" value={pricelist.rentalWarning} onChange={(e)=>setPricelist({...pricelist, rentalWarning: e.target.value})} style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}/>

                <p style={{color: 'lightgreen'}}>{message}</p>
                <div style={{textAlign: 'center'}}><button type="submit" style={{background: '#FFC93C', padding: '14px 40px', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer'}}>Uložiť cenník</button></div>
            </form> : <p style={{color: 'white', textAlign: 'center'}}>Načítavam...</p>}
        </div>
        : dashChoice === 12 && deleteDash === 0 ?
        <div className="content">
            <div className="header"><h1>Pridať upozornenie</h1></div>
            <div className="login-form">
                <form method="POST" onSubmit={(e)=>formWarning(e)}>
                    <label for="warningHeader">Názov upozornenia</label>
                    <input type="text" onChange={(e)=>setWarningHeader(e.target.value)} id="warningHeader" name="warningHeader" placeholder="napr. Zákon prikazuje!"/>

                    <label for="warningText">Text</label><br/>
                    <textarea onChange={(e)=>setWarningText(e.target.value)}></textarea>

                    <p>Upozornenie sa zobrazí v červenej sekcii „Upozornenia“ na hlavnej stránke.</p>
                    <p style={{color: 'lightgreen'}}>{message}</p>
                    <div style={{textAlign: 'center'}}><input type="submit" value="Pridaj upozornenie"/></div>
                </form>
            </div>
        </div>
        : dashChoice === 15 && deleteDash === 0 ?
        <div className="content">
            <div className="header"><h1>Kamera</h1></div>
            <div className="login-form">
                <div style={{marginBottom: '20px', padding: '15px', borderRadius: '10px', background: cameraHidden ? 'rgba(255,80,80,0.15)' : 'rgba(80,255,140,0.12)'}}>
                    <p style={{margin: 0, color: cameraHidden ? '#ff9b9b' : 'lightgreen'}}>
                        <strong>Aktuálny stav:</strong>{' '}
                        {cameraHidden
                            ? (cameraHiddenUntil
                                ? `Kamera je skrytá do ${formatUntil(cameraHiddenUntil)}`
                                : 'Kamera je skrytá (až do manuálneho zapnutia)')
                            : 'Kamera je viditeľná'}
                    </p>
                </div>

                {cameraHidden ? (
                    <div style={{textAlign: 'center', marginBottom: '25px'}}>
                        <input type="button" value="Zobraziť kameru teraz" onClick={showCamera}/>
                    </div>
                ) : null}

                <form method="POST" onSubmit={(e)=>hideCamera(e)}>
                    <label>Na ako dlho skryť kameru?</label>
                    <div style={{color: 'white', marginBottom: '15px'}}>
                        <div style={{marginBottom: '8px'}}>
                            <input type="radio" id="cam-duration" name="cameraHideMode" value="duration"
                                checked={cameraHideMode === 'duration'}
                                onChange={()=>setCameraHideMode('duration')} style={{width: 'auto', marginRight: '8px'}}/>
                            <label htmlFor="cam-duration" style={{display: 'inline'}}>Na určitý počet hodín</label>
                        </div>
                        <div style={{marginBottom: '8px'}}>
                            <input type="radio" id="cam-until" name="cameraHideMode" value="until"
                                checked={cameraHideMode === 'until'}
                                onChange={()=>setCameraHideMode('until')} style={{width: 'auto', marginRight: '8px'}}/>
                            <label htmlFor="cam-until" style={{display: 'inline'}}>Do konkrétneho dátumu a času</label>
                        </div>
                        <div>
                            <input type="radio" id="cam-forever" name="cameraHideMode" value="forever"
                                checked={cameraHideMode === 'forever'}
                                onChange={()=>setCameraHideMode('forever')} style={{width: 'auto', marginRight: '8px'}}/>
                            <label htmlFor="cam-forever" style={{display: 'inline'}}>Natrvalo (kým ju znova nezapnem)</label>
                        </div>
                    </div>

                    {cameraHideMode === 'duration' ? <>
                        <label htmlFor="cameraHours">Počet hodín</label>
                        <select id="cameraHours" value={cameraHideHours} onChange={(e)=>setCameraHideHours(e.target.value)}>
                            <option value="0.5">30 minút</option>
                            <option value="1">1 hodina</option>
                            <option value="2">2 hodiny</option>
                            <option value="3">3 hodiny</option>
                            <option value="6">6 hodín</option>
                            <option value="12">12 hodín</option>
                            <option value="24">1 deň</option>
                            <option value="48">2 dni</option>
                            <option value="168">7 dní</option>
                        </select>
                    </> : null}

                    {cameraHideMode === 'until' ? <>
                        <label htmlFor="cameraUntil">Skryť do</label>
                        <input type="datetime-local" id="cameraUntil" value={cameraHideUntilInput}
                            onChange={(e)=>setCameraHideUntilInput(e.target.value)}/>
                    </> : null}

                    <label htmlFor="cameraMessage">Text zobrazený namiesto kamery</label>
                    <input type="text" id="cameraMessage" value={cameraMessage}
                        onChange={(e)=>setCameraMessage(e.target.value)}
                        placeholder="napr. Kamera je dočasne mimo prevádzky"/>

                    <p>Kým je kamera skrytá, záznam sa nezobrazí na stránke Záznamy kamier ani v bočnom paneli. Po uplynutí nastaveného času sa kamera zapne automaticky.</p>
                    <p style={{color: 'lightgreen'}}>{message}</p>
                    <div style={{textAlign: 'center'}}><input type="submit" value={cameraHidden ? 'Upraviť skrytie' : 'Skryť kameru'}/></div>
                </form>
            </div>
        </div>
        : dashChoice === 11 && deleteDash === 0 ?
        <div className="content">
            <div className="header"><h1>Otvaracie hodiny</h1></div>
            <div className="login-form">
                <form method="POST" onSubmit={(e)=>saveOpeningHoursData(e)}>
                    <label>Režim otváracích hodín:</label>
                    <div style={{marginBottom: '20px'}}>
                        <label style={{marginRight: '20px'}}>
                            <input 
                                type="radio" 
                                value="static" 
                                checked={openingMode === 'static'} 
                                onChange={(e) => setOpeningMode(e.target.value)}
                            />
                            Statické (rovnaké každý týždeň)
                        </label>
                        <label>
                            <input 
                                type="radio" 
                                value="dynamic" 
                                checked={openingMode === 'dynamic'} 
                                onChange={(e) => setOpeningMode(e.target.value)}
                            />
                            Dynamické (nastavenie dátumov)
                        </label>
                    </div>

                    {openingMode === 'static' ? (
                        <>
                            {isSummer ? (
                                <>
                                    <h3 style={{color: 'white', marginTop: '20px'}}>Bufet</h3>
                                    {['PO', 'UT', 'ST', 'ŠT', 'PI', 'SO', 'NE'].map(day => (
                                        <div key={day} style={{marginBottom: '10px'}}>
                                            <label>{day}:</label>
                                            <input 
                                                type="text" 
                                                value={staticHours.bufet?.[day] || ''} 
                                                onChange={(e) => handleStaticHoursChange('bufet', day, e.target.value)}
                                                placeholder="napr. 16:00 - 20:00 alebo ZATVORENÉ"
                                                style={{width: '200px', marginLeft: '10px'}}
                                            />
                                        </div>
                                    ))}
                                    
                                    <h3 style={{color: 'white', marginTop: '20px'}}>Traily</h3>
                                    {['PO', 'UT', 'ST', 'ŠT', 'PI', 'SO', 'NE'].map(day => (
                                        <div key={day} style={{marginBottom: '10px'}}>
                                            <label>{day}:</label>
                                            <input 
                                                type="text" 
                                                value={staticHours.traily?.[day] || ''} 
                                                onChange={(e) => handleStaticHoursChange('traily', day, e.target.value)}
                                                placeholder="napr. 13:00 - 17:00 alebo ZATVORENÉ"
                                                style={{width: '200px', marginLeft: '10px'}}
                                            />
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    <h3 style={{color: 'white', marginTop: '20px'}}>Otváracie hodiny</h3>
                                    {['PO', 'UT', 'ST', 'ŠT', 'PI', 'SO', 'NE'].map(day => (
                                        <div key={day} style={{marginBottom: '10px'}}>
                                            <label>{day}:</label>
                                            <input 
                                                type="text" 
                                                value={staticHours.openingHours?.[day] || ''} 
                                                onChange={(e) => handleStaticHoursChange('openingHours', day, e.target.value)}
                                                placeholder="napr. 9:00 - 16:00 alebo ZATVORENÉ"
                                                style={{width: '200px', marginLeft: '10px'}}
                                            />
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <p style={{color: 'white', marginBottom: '20px'}}>Nastavte otváracie hodiny pre nasledujúcich 14 dní. Zobrazia sa iba najbližšie 7 dní od dnes.</p>
                            <button type="button" onClick={addDynamicDate} style={{marginBottom: '20px', padding: '10px'}}>
                                Pridať dátum
                            </button>
                            
                            {dynamicDates.map((dateItem, index) => (
                                <div key={index} style={{border: '1px solid #ccc', padding: '15px', marginBottom: '15px', borderRadius: '5px'}}>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Dátum:</label>
                                        <input 
                                            type="date" 
                                            value={dateItem.date || ''} 
                                            onChange={(e) => handleDynamicDateChange(index, 'date', e.target.value)}
                                            min={new Date().toISOString().split('T')[0]}
                                            max={new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                                            style={{marginLeft: '10px', padding: '5px'}}
                                        />
                                        <button 
                                            type="button" 
                                            onClick={() => removeDynamicDate(index)}
                                            style={{marginLeft: '10px', padding: '5px 10px', background: 'red'}}
                                        >
                                            Odstrániť
                                        </button>
                                    </div>
                                    {isSummer ? (
                                        <>
                                            <div style={{marginBottom: '10px'}}>
                                                <label>Bufet:</label>
                                                <input 
                                                    type="text" 
                                                    value={dateItem.bufet || ''} 
                                                    onChange={(e) => handleDynamicDateChange(index, 'bufet', e.target.value)}
                                                    placeholder="napr. 16:00 - 20:00 alebo ZATVORENÉ"
                                                    style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                                                />
                                            </div>
                                            <div>
                                                <label>Traily:</label>
                                                <input 
                                                    type="text" 
                                                    value={dateItem.traily || ''} 
                                                    onChange={(e) => handleDynamicDateChange(index, 'traily', e.target.value)}
                                                    placeholder="napr. 13:00 - 17:00 alebo ZATVORENÉ"
                                                    style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <div>
                                            <label>Otváracie hodiny:</label>
                                            <input 
                                                type="text" 
                                                value={dateItem.openingHours || ''} 
                                                onChange={(e) => handleDynamicDateChange(index, 'openingHours', e.target.value)}
                                                placeholder="napr. 9:00 - 16:00 alebo ZATVORENÉ"
                                                style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </>
                    )}

                    <h3 style={{color: 'white', marginTop: '30px'}}>Aktuálny stav</h3>
                    <div style={{marginBottom: '15px'}}>
                        <label>Svahy v prevádzke:</label>
                        <input 
                            type="text" 
                            value={currentStatus.openSlopes || ''} 
                            onChange={(e) => setCurrentStatus({...currentStatus, openSlopes: e.target.value})}
                            placeholder="napr. 3"
                            style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                        />
                    </div>
                    <div style={{marginBottom: '15px'}}>
                        <label>Vleky v prevádzke:</label>
                        <input 
                            type="text" 
                            value={currentStatus.openLifts || ''} 
                            onChange={(e) => setCurrentStatus({...currentStatus, openLifts: e.target.value})}
                            placeholder="napr. 2"
                            style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                        />
                    </div>
                    <div style={{marginBottom: '15px'}}>
                        <label>Počet cm snehu:</label>
                        <input 
                            type="text" 
                            value={currentStatus.snowDepth || ''} 
                            onChange={(e) => setCurrentStatus({...currentStatus, snowDepth: e.target.value})}
                            placeholder="napr. 25"
                            style={{width: '200px', marginLeft: '10px', padding: '5px'}}
                        />
                    </div>

                    <p style={{color: 'lightgreen', textAlign: 'center', marginTop: '20px'}}>{message}</p>
                    <div style={{textAlign: 'center', marginTop: '20px'}}>
                        <input type="submit" value="Uložiť"/>
                    </div>
                </form>
            </div>
        </div>
        : deleteDash === 1 && deleteDashChoice === 1 ?
        <div className="content">
            <div className="header"><h1>Odstrániť informáciu</h1></div>
            <p style={{color: 'gray', textAlign: 'center'}}>Kliknutím na riadok v tabuľke vymažete vybranú informáciu.</p>
            <p style={{color: 'lightgreen', textAlign: 'center'}}>{message}</p>
            <table id="events-table" style={{margin: '20px auto', textAlign: 'center'}}>
                <tbody>
                    <tr>
                        <th style={{paddingLeft: '10px'}}>Názov</th>
                        <th style={{paddingLeft: '10px'}}>Pridané</th>
                    </tr>
                    {deleteInformationList.map((info) => (
                        <tr key={info.id} onClick={() => handleDeleteInformation(info.id, info.header)} style={{cursor: 'pointer'}}>
                            <td>{info.header}</td>
                            <td>{fixedDate(info.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {deleteInformationList.length === 0 && <p style={{color: 'white', textAlign: 'center'}}>Žiadne informácie na vymazanie.</p>}
        </div> : deleteDash === 1 && deleteDashChoice === 2 ? <div className="content">
            <div className="header"><h1>Odstrániť podujatie</h1></div>
            <p style={{color: 'gray', textAlign: 'center'}}>Kliknutím na riadok v tabuľke vymažete vybrané podujatie.</p>
            <p style={{color: 'lightgreen', textAlign: 'center'}}>{message}</p>
            <table id="events-table" style={{margin: '20px auto', textAlign: 'center'}}>
                <tbody>
                    <tr>
                        <th style={{paddingLeft: '10px'}}>Názov</th>
                        <th style={{paddingLeft: '10px'}}>Pridané</th>
                    </tr>
                    {deleteEventsList.map((event) => (
                        <tr key={event.id} onClick={() => handleDeleteEvent(event.id, event.header)} style={{cursor: 'pointer'}}>
                            <td>{event.header}</td>
                            <td>{fixedDate(event.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {deleteEventsList.length === 0 && <p style={{color: 'white', textAlign: 'center'}}>Žiadne podujatia na vymazanie.</p>}
        </div> : deleteDash === 1 && deleteDashChoice === 3 ? <div className="content">
            <div className="header"><h1>Odstrániť upozornenie</h1></div>
            <p style={{color: 'gray', textAlign: 'center'}}>Kliknutím na riadok v tabuľke vymažete vybrané upozornenie.</p>
            <p style={{color: 'lightgreen', textAlign: 'center'}}>{message}</p>
            <table id="events-table" style={{margin: '20px auto', textAlign: 'center'}}>
                <tbody>
                    <tr>
                        <th style={{paddingLeft: '10px'}}>Názov</th>
                        <th style={{paddingLeft: '10px'}}>Pridané</th>
                    </tr>
                    {deleteWarningsList.map((warning) => (
                        <tr key={warning.id} onClick={() => handleDeleteWarning(warning.id, warning.header)} style={{cursor: 'pointer'}}>
                            <td>{warning.header}</td>
                            <td>{fixedDate(warning.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {deleteWarningsList.length === 0 && <p style={{color: 'white', textAlign: 'center'}}>Žiadne upozornenia na vymazanie.</p>}
        </div> : deleteDash === 1 && deleteDashChoice === 4 ? <div className="content">
            <div className="header"><h1>Odstrániť dôležité info</h1></div>
            <p style={{color: 'gray', textAlign: 'center'}}>Kliknutím na riadok v tabuľke vymažete vybrané dôležité info (banner na úvodnej stránke).</p>
            <p style={{color: 'lightgreen', textAlign: 'center'}}>{message}</p>
            <table id="events-table" style={{margin: '20px auto', textAlign: 'center'}}>
                <tbody>
                    <tr>
                        <th style={{paddingLeft: '10px'}}>Názov</th>
                        <th style={{paddingLeft: '10px'}}>Pridané</th>
                    </tr>
                    {deleteImportantList.map((item) => (
                        <tr key={item.id} onClick={() => handleDeleteImportant(item.id, item.header)} style={{cursor: 'pointer'}}>
                            <td>{item.header}</td>
                            <td>{fixedDate(item.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {deleteImportantList.length === 0 && <p style={{color: 'white', textAlign: 'center'}}>Žiadne dôležité info na vymazanie.</p>}
        </div> : ""}
        </> : ""}
    </div>
  )
}

export default Dashboard